export var COLLECTORS = 'metrics_collectors';
export var DESTROYED = 'is_destroyed';
export var EVENTS = 'events_publisher';
export var READINESS = 'readiness_gate';
export var READY = 'is_ready';
export var READY_FROM_CACHE = 'is_ready_from_cache';
export var SETTINGS = 'settings';
export var STATUS_MANAGER = 'status_manager';
export var STORAGE = 'storage';
export default {
  COLLECTORS: COLLECTORS,
  DESTROYED: DESTROYED,
  EVENTS: EVENTS,
  READINESS: READINESS,
  READY: READY,
  READY_FROM_CACHE: READY_FROM_CACHE,
  SETTINGS: SETTINGS,
  STATUS_MANAGER: STATUS_MANAGER,
  STORAGE: STORAGE
};


// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio/es/utils/context/constants.js